<template>
  <q-btn
    data-test-id="account-menu"
    flat
    round
    :dense="$q.screen.lt.sm"
    size="12px"
    icon="fal fa-user"
    aria-label="Menu"
    @click="accountMenuOpen ? $trackEvent($customerEvents.CLOSED_ACCOUNT_MENU) : $trackEvent($customerEvents.OPENED_ACCOUNT_MENU)"
  >
    <q-menu
      v-model="accountMenuOpen"
      bordered
      side="right"
      overlay
    >
      <q-list
        class="drawer-content"
      >
        <q-item
          v-if="!loggedIn"
          v-ripple
          clickable
          :to="{ name: 'auth:register' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-user"
              size="xs"
            />
          </q-item-section>
          <q-item-section>
            {{ $t('auth.actions.register') }}
          </q-item-section>
        </q-item>

        <q-item
          v-if="!loggedIn"
          v-ripple
          clickable
          :to="{ name: 'auth:login' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-right-to-bracket"
              size="sm"
            />
          </q-item-section>
          <q-item-section>
            {{ $t('auth.actions.login') }}
          </q-item-section>
        </q-item>

        <q-item
          v-if="loggedIn"
          v-ripple
          clickable
          :to="{ name: 'auth:account' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-user"
              size="xs"
            />
          </q-item-section>
          <q-item-section>
            {{ $tc('user.account', 1) }}
          </q-item-section>
        </q-item>
        <q-item
          v-if="loggedIn"
          v-ripple
          clickable
          :to="{ name: 'consumer:orders' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-ticket"
              size="xs"
            />
          </q-item-section>
          <q-item-section>
            {{ $tc('order.order', 2) }}
          </q-item-section>
        </q-item>
        <q-item
          v-if="loggedIn"
          v-ripple
          clickable
          :to="{ name: 'consumer:my-membership' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-id-card"
              size="xs"
            />
          </q-item-section>
          <q-item-section>
            {{ $tc('membership.membership', 1) }}
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-if="loggedIn"
          v-ripple
          clickable
          :to="{ name: 'auth:logout' }"
          exact
        >
          <q-item-section avatar>
            <q-icon
              name="fal fa-right-from-bracket"
              size="xs"
            />
          </q-item-section>
          <q-item-section>
            {{ $t('auth.actions.logout') }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
export default {
  name: 'AccountMenuButton',
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      accountMenuOpen: false
    }
  }
}
</script>
